<template>
  <div class="row">
    <div class="col-md-12">
      <div class="card">
        <div class="card-body">
          <!-- <PRE>

            {{ compra }}
          </PRE> -->
          <h5 class="card-title">Detalle de compra Folio. {{ compra.id_buy }}</h5>
          <h6 class="card-subtitle mb-2 text-muted">{{compra.orders[0].providerName}}</h6>
          <h6 class="card-subtitle mb-2 text-muted">{{compra.fullname}}</h6>
          <h6 class="card-subtitle mb-2 text-muted">{{compra.status}}</h6>
          <div class="card mt-5">
            <div class="card-header row">
                <div class="col-lg-6">Información General</div>
                <!-- <div class="text-right col-lg-6">
                    <button @click="editarInfo">editar</button>
                </div> -->
            </div>
            <div class="card-body">
              <div class="row">
                <div class="col-md-3 text-center">
                  <h6>Cantidad de productos</h6>
                </div>
                <div class="col-md-3 text-center">
                  <h6>Total de compra</h6>
                </div>
                <div class="col-md-3 text-center">
                  <h6>Fecha de compra</h6>
                </div>
                <div class="col-md-3 text-center">
                  <h6>Registro</h6>
                </div>
              </div>

              <div class="row">
                <div class="col-md-3 text-center" style="color: #007bff"><b>{{ compra.quantity_products }}</b></div>
                <div class="col-md-3 text-center" style="color: #007bff"><b><span v-html="getFormattedAmount(compra.amount)" /></b></div>
                <div class="col-md-3 text-center" style="color: #007bff"><b>{{ compra.date }}</b></div>
                <div class="col-md-3 text-center" style="color: #007bff"><b>{{ compra.user_name }}</b></div>
              </div>
            </div>
          </div>

          <div class="card mt-3">
            <div class="card-header">
              Relación de productos comprados
              <div class="row justify-content-end">
                <button v-if="myRoleId === 1" class="btn btn-danger mr-4" @click="cancelPurchase">Cancelar compra</button>
                <button class="btn btn-purple mr-4" @click="printCompra">Imprimir reporte</button>
                <button class="btn btn-purple" @click="printEtiquetas">Imprimir etiquetas</button>
              </div>
            </div>
            <!-- {{tickets}} -->
            <div class="card-body">
              <b-table
                striped
                selectable
                class="table-adelantazo"
                select-mode="multi"
                selectedVariant="success"
                responsive="sm"
                show-empty
                stacked="md"
                :items="items"
                :fields="fields"
                :current-page="currentPage"
                :per-page="perPage"
                :filter="filter"
                :sort-by.sync="sortBy"
                :sort-desc.sync="sortDesc"
                :sort-direction="sortDirection"
                @row-selected="onRowSelected"
              >
                 <template v-slot:cell(fullname)="row">
                  <div align="center" class="history-amount">
                    <span style="font-size: 10px">{{row.item.fullname}}</span>
                  </div>
                </template>
                <template v-slot:cell(precio)="row">
                  <div align="center" class="history-amount">
                    <span v-html="getFormattedAmount(row.item.precio)" />
                  </div>
                </template>
                <template v-slot:cell(descuento)="row">
                  <div align="center" class="history-amount">
                    <span v-html="getFormattedAmount(row.item.descuento)" />
                  </div>
                </template>
                <template v-slot:cell(costo_tienda)="row">
                  <div align="center" class="history-amount">
                    <span style="color: green" v-html="getFormattedAmount(row.item.costo_tienda)" />
                  </div>
                </template>
                <template v-slot:cell(venta)="row">
                  <div align="center" class="history-amount">
                    <span v-html="getFormattedAmount(row.item.venta)" />
                  </div>
                </template>
                <template v-slot:cell(porcentaje_descuento)="row">
                  <div align="center" class="history-amount">
                     <span>{{row.item.porcentaje_descuento}} %</span>
                  </div>
                </template>
                <template v-slot:cell(porcentaje_descuento_nosotros)="row">
                  <div align="center" class="history-amount">
                     <span>{{row.item.porcentaje_descuento_nosotros}} %</span>
                  </div>
                </template>
                <template v-slot:cell(actions)="row">
                  <div align="center" class="history-amount">
                    <button v-if="myRoleId === 1" class="btn btn-purple" @click="editRow(row)">
                      <font-awesome-icon :icon="['fa', 'pen']" />
                    </button>
                  </div>
                </template>
              <!-- <div slot="RequestDate" slot-scope="row">{{ row }}</div> -->
            </b-table>
            </div>
          </div>

        </div>
      </div>
    </div>
    <vue-html2pdf
        :show-layout="false"
        :float-layout="true"
        :enable-download="false"
        :preview-modal="true"
        :paginate-elements-by-height="1400"
        :filename="`Labels-Order`"
        :pdf-quality="2"
        :manual-pagination="false"
        pdf-format="a4"
        :htmlToPdfOptions = "htmlToPdfOptions"
        pdf-orientation="portrait"
        ref="html2Pdf"
      >
        <section slot="pdf-content" class="">
          <section class="parent" >
            <div class="div1"   v-for="(item, index) in tickets" :key="item.id_order">
              <div v-bind:class="[index > 2 ? 'row justify-content-center' : 'row justify-content-center']">
                <!-- <VueBarcode :value="item.barcode" format="Codabar"  textPosition="top" :options="barcode_option" height="30" width="2" font-size="10"/> -->
                <VueBarcode :value="item.barcode" format="CODE39"  textPosition="top" :options="barcode_option" height="35" width="1" font-size="9"/>
              </div>
              <div class="row justify-content-center printLabels">
                <div class="col-lg-10 text-left">
                  <p style="font-size: 6px;">{{item.key_client}} - {{item.name}} {{item.lastname}} {{item.lastname2}} &nbsp; &nbsp;{{ item.key_provider + item.siglas}} - {{item.modelo}} - {{item.color}} - {{item.numero}} </p>
                  <!-- <p class="endLabels"><b>{{item.sucursal}}</b> - Compra: {{item.date_buy}}</p> -->
                  <p class="endLabels">{{item.sucursal}}/{{ item.provider }}/{{item.date_buy}}</p>
                </div>
              </div>
            </div>
          </section>
        </section>
      </vue-html2pdf>
    <!-- <vue-html2pdf
        :show-layout="false"
        :float-layout="false"
        :enable-download="false"
        :preview-modal="true"
        :paginate-elements-by-height="1400"
        :filename="`Labels-Order`"
        :pdf-quality="2"
        :manual-pagination="false"
        pdf-format="a4"
        :htmlToPdfOptions = "htmlToPdfOptions"
        pdf-orientation="portrait"
        pdf-content-width="100%"
        ref="html2Pdf"
      >
        <section slot="pdf-content">
          <section class="pdf-item labelsComplete">
            <div class="etiqueta col" v-for="item in tickets" :key="item.id_order">
              <div v-bind:class="[index > 2 ? 'row justify-content-center mt-1' : 'row justify-content-center']">
                <VueBarcode :value="item.barcode" format="CODE39"  textPosition="top" :options="barcode_option" height="50" width="1" font-size="10"/>
                <br>
                <p><b>{{ item.barcode }}</b></p>
              </div>
              <div class="row justify-content-center printLabels">
                <div class="col-lg-10 text-left">
                  <p><b>{{item.key_client}}</b> - {{item.name}} {{item.lastname}} {{item.lastname2}} </p>
                  <p><b>{{item.siglas}}</b> - {{item.marca}} - {{item.model}} - {{item.color}} - {{item.numero}}</p>
                  <p class="endLabels"><b>{{item.sucursal}}</b> - Compra: {{item.date_buy}}</p>
                </div>
              </div>
            </div>
          </section>
        </section>
      </vue-html2pdf> -->
      <vue-html2pdf
        :show-layout="false"
        :float-layout="true"
        :enable-download="false"
        :preview-modal="true"
        :paginate-elements-by-height="1400"
        :filename="`Labels-Order`"
        :pdf-quality="2"
        :manual-pagination="true"
        pdf-format="a4"
        pdf-orientation="portrait"
        pdf-content-width="100%"
        ref="reporte"
      >
        <section slot="pdf-content">
          <section class="pdf-item">
            <div class="printCompra">
              <div class="container">
                <div class="row mt-5">
                  <div class="col-lg-12">
                    FOLIO: {{ compra.id_buy }}
                  </div>
                </div>
                <div class="row">
                  <div class="col-lg-12">
                    Fecha de compra: {{ compra.date }}
                  </div>
                </div>
                <div class="row">
                  <div class="col-lg-6">
                    Tienda: {{compra.name}}
                  </div>
                  <div class="col-lg-6">
                    Usuario que registro: {{ compra.user_name }}
                  </div>
                </div>
                <div class="row justify-content-center mt-3">
                  Total de compra: $ {{ compra.amount | formatNumberCurrency }}
                </div>
                <div class="row justify-content-center mt-5">
                  <div class="title">Relacion de productos</div>
                </div>
                <div class="mt-3">
                  <table>
                    <colgroup span="4" class="columns"></colgroup>
                    <tr class="text-center">
                      <th>Cantidad</th>
                      <th>Producto</th>
                      <th>Precio Cliente</th>
                      <th>Descuento</th>
                      <th>Costo Cliente</th>
                      <th>Costo Tienda</th>
                    </tr>
                    <tr v-for="item in items" :key="item.id_order">
                      <td>{{ item.cantidad }}</td>
                      <td>{{ item.marca + '-' + item.modelo + '-' + item.color + '-' + item.numero }}</td>
                      <td>$ {{ item.precio | formatNumberCurrency}}</td>
                      <td>$ {{ item.descuento | formatNumberCurrency}}</td>
                      <td>$ {{ item.venta | formatNumberCurrency}}</td>
                      <td>$ {{ item.costo_tienda | formatNumberCurrency}}</td>
                    </tr>
                    <tr>
                      <td colspan="5" class="text-right">Total:  </td>
                      <td>$ {{ compra.amount | formatNumberCurrency }}</td>
                    </tr>
                  </table>
                </div>
              </div>
            </div>
          </section>
        </section>
      </vue-html2pdf>
      <modal name="editBuy" :scrollable="true" height="850" class="">
      <div class="text-right">
        <span class="close-modal" @click="$modal.hide('editBuy')">
          <font-awesome-icon :icon="['fa', 'times-circle']" />
        </span>
      </div>
      <div class="reset-pass">
        <h2 class="text-center">EDITAR COMPRA</h2>
        <div class="col-11">
          <b-card no-body  style="overflow:auto;">
            <b-tabs card  style="overflow:auto;">
              <!-- {{ rowSelected }} -->
              <b-tab title="INFORMACIÓN BASE" no-body>
                <div class="form-group row">
                  <div class="col-3">
                    <label for="exampleInputEmail1">Cliente </label>
                    <input type="number" class="form-control ml-3" v-model="rowSelected.id_client" id="exampleInputEmail1" aria-describedby="emailHelp" placeholder="Nombre" @change="changeClient">
                  </div>
                  <div class="col-8 mt-4">{{ rowSelected.fullname }}</div>
                </div>
                <div class="form-group col-11">
                    <label for="exampleInputPassword1">Catalogo</label>
                    <input type="text" class="form-control ml-3" v-model="rowSelected.catalogo" placeholder="CATALOGO">
                </div>
                <div class="form-group col-11">
                    <label for="exampleInputPassword1">Marca</label>
                    <input type="text" class="form-control ml-3" v-model="rowSelected.marca" placeholder="MARCA">
                </div>
                <div class="form-group col-11">
                    <label for="exampleInputPassword1">Modelo</label>
                    <input type="text" class="form-control ml-3" v-model="rowSelected.modelo" placeholder="MODELO">
                </div>
                <div class="form-group col-11">
                    <label for="exampleInputPassword1">Color</label>
                    <input type="text" class="form-control ml-3" v-model="rowSelected.color" placeholder="COLOR">
                </div>
                <div class="form-group col-11">
                    <label for="exampleInputPassword1">Talla</label>
                    <input type="phone" class="form-control ml-3" v-model="rowSelected.numero" placeholder="TALLA">
                </div>
                <div class="text-center">
                    <button type="submit" class="btn btn-primary text-center" @click="updateInfo">Actualizar</button>
                </div>
              </b-tab>
              <b-tab title="INFORMACIÓN COSTOS">
                <!-- {{ rowSelected }} -->
                <div class="form-group col-11">
                  <label for="exampleInputEmail1">PRECIO CLIENTE </label>
                  <input type="text" class="form-control ml-3" v-model="rowSelected.precio" placeholder="PRECIO DE CLIENTE" @change="changePrice">
                </div>
                <div class="form-group col-11">
                    <label for="exampleInputPassword1">% DE DESCUENTO</label>
                    <input type="number" class="form-control ml-3" v-model="rowSelected.porcentaje_descuento" placeholder="Dirección" @change="changePrice">
                </div>
                <div class="form-group col-11">
                    <label for="exampleInputPassword1">% DESCUENTO DE LA TIENDA</label>
                    <input type="number" class="form-control ml-3" v-model="rowSelected.porcentaje_descuento_nosotros" placeholder="Estado" @change="changePrice">
                </div>
                <div class="form-group col-11">
                    <label for="exampleInputPassword1">PRECIO FINAL VENTA</label>
                    <input type="text" class="form-control ml-3" v-model="rowSelected.venta" placeholder="Ciudad" >
                </div>
                <div class="form-group col-11">
                    <label for="exampleInputPassword1">COSTO TIENDA</label>
                    <input type="phone" class="form-control ml-3" v-model="rowSelected.costo_tienda" placeholder="Teléfono">
                </div>
                <div class="text-center">
                    <button type="submit" class="btn btn-primary text-center" @click="updateInfo">Actualizar</button>
                </div>
              </b-tab>
            </b-tabs>
          </b-card>
        </div>
      </div>
    </modal>
  </div>
</template>

<script>
import axiosAdelaService from '@/axios/axiosAdelaService'
import formatData from '@/mixins/formatAxios'
import { mapGetters } from 'vuex'
import moment from 'moment'
import VueHtml2pdf from 'vue-html2pdf'
import VueBarcode from 'vue-barcode'
import { BCard, BTabs, BTab, BTable } from 'bootstrap-vue'

export default {
  mixins: [formatData],
  components: {
    BTable,
    VueHtml2pdf,
    VueBarcode,
    BCard,
    BTabs,
    BTab
  },
  data () {
    return {
      rowSelected: [],
      barcode_option: {
        // height="18" width="2" font-size="10"
        // format: 'EAN13',
        // lineColor: '#0aa',
        // height: 35
        format: 'pharmacode',
        lineColor: '#0aa',
        width: 1,
        height: 15,
        displayValue: false
      },
      htmlToPdfOptions: {
        margin: [10, 0, 10, 0],
        filename: 'algo',
        html2canvas: {
          scale: 3,
          useCORS: true
        }
      },
      htmlToPdfOptions2: {
        margin: 0,
        filename: 'hehehe.pdf',
        image: {
          type: 'jpeg',
          quality: 0.98
        },
        enableLinks: false,
        html2canvas: {
          scale: 1,
          useCORS: true
        },
        jsPDF: {
          unit: 'in',
          format: 'a4',
          orientation: 'portrait'
        }
      },
      selected: [],
      compra: null,
      items: [],
      fields: [
        { key: 'barcode', label: 'Codigo', sortable: true, sortDirection: 'desc', thClass: 'text-center', tdClass: 'rowTable text-center' }, // cliente
        { key: 'fullname', label: 'Cliente', sortable: true, sortDirection: 'desc', thClass: 'text-center', tdClass: 'rowTable text-center' }, // cliente
        { key: 'marca', label: 'Marca', sortable: true, sortDirection: 'desc', thClass: 'text-center', tdClass: 'rowTable text-center' },
        { key: 'modelo', label: 'Modelo', sortable: true, sortDirection: 'desc', thClass: 'text-center', tdClass: 'rowTable text-center' },
        { key: 'color', label: 'Color', sortable: true, sortDirection: 'desc', thClass: 'text-center', tdClass: 'rowTable text-center' },
        { key: 'numero', label: 'Talla', sortable: true, sortDirection: 'desc', thClass: 'text-center', tdClass: 'rowTable text-center' },
        { key: 'precio', label: 'Precio cliente', thClass: 'text-center', tdClass: 'rowTable text-center' },
        { key: 'porcentaje_descuento', label: '% Desc Cliente', thClass: 'text-center', tdClass: 'rowTable text-center' },
        { key: 'descuento', label: 'Desc $', thClass: 'text-center', tdClass: 'rowTable text-center' },
        { key: 'venta', label: 'Costo Cliente', thClass: 'text-center', tdClass: 'rowTable text-center' },
        { key: 'porcentaje_descuento_nosotros', label: '% Nosotros', thClass: 'text-center', tdClass: 'rowTable text-center' },
        { key: 'cantidad', label: 'Cantidad', sortable: true, sortDirection: 'desc', thClass: 'text-center', tdClass: 'rowTable text-center' },
        { key: 'costo_tienda', label: 'Costo tienda', thClass: 'text-center', tdClass: 'rowTable text-right' },
        { key: 'actions', label: 'Acciones' }
      ],
      currentPage: 1,
      perPage: 50,
      pageOptions: [50, 100],
      sortBy: null,
      sortDesc: false,
      sortDirection: 'asc',
      filter: null,
      tickets: []
    }
  },
  computed: {
    ...mapGetters({
      user: 'getUser'
    }),
    horaActual () {
      return moment.utc().format('HH:mm:ss')
    },
    myRoleId () {
      return this.$store.getters.currentRoleId
    }
  },
  methods: {
    cancelPurchase () {
      console.log('Cancelar compra')
      this.$dialog.confirm(`
        <div class="row justify-content-center">
          <div class="col-lg-10 text-center">
            <h4 style="color:red"><b>Por favor, confirma que deseas cancelar la compra.</b></h4>
          </div>
        </div>
      `)
        .then(async () => {
          const request = {
            id_buy: this.compra.id_buy,
            enterprise: this.user.enterprise_id
          }
          const response = await axiosAdelaService.post('/cancelBuy', request)
          console.log(response)
          this.$toastedPush({
            message: response.data.msg,
            type: 'success'
          })
          this.$router.push({ name: 'compras' })
        })
        .catch((err) => {
          console.log('presiono cancelar confirmationDialog', err)
        })
    },
    changePrice () {
      console.log('CAMBIO EL PRECIO DE CLIENTE', this.rowSelected.precio)
      // this.rowSelected.precio =  this.rowSelected.precio
      this.rowSelected.descuento = (this.rowSelected.precio * this.rowSelected.porcentaje_descuento) / 100
      this.rowSelected.venta = (this.rowSelected.precio - this.rowSelected.descuento).toFixed(2)
      this.rowSelected.costo_tienda = (this.rowSelected.precio - ((this.rowSelected.precio * this.rowSelected.porcentaje_descuento_nosotros) / 100)).toFixed(2)
    },
    async changeClient () {
      try {
        const request = {
          enterprise_id: this.user.enterprise_id,
          id_client: this.rowSelected.id_client
        }
        console.log(request)
        const customer = await axiosAdelaService.post('/getClientByKey', request)
        console.log('abonnos', customer)
        if (customer.status === 200) {
          this.rowSelected.fullname = customer.data.rows.fullname
          this.$toastedPush({
            message: 'Cliente actualizado',
            type: 'success'
          })
        }
      } catch (error) {
        this.showError('No se pudieron obtener los datos intentalo mas tarde.')
      }
    },
    editRow (arg) {
      console.log(arg)
      this.rowSelected = arg.item
      this.$modal.show('editBuy')
    },
    onRowSelected (items) {
      this.selected = items
    },
    getFormattedAmount (amount) {
      if (amount) {
        return '$ ' + this.$formatNumberCurrency(amount, 'MXN') + ' <span class="mxn">MXN</span>'
      } else {
        return ''
      }
    },
    async updateInfo () {
      try {
        const request = {
          ...this.rowSelected
        }
        console.log(request)
        const abonos = await axiosAdelaService.post('/updateOrderById', request)
        // console.log('abonnos', abonos)
        if (abonos.status === 200) {
          this.$toastedPush({
            message: 'Cliente actualizado',
            type: 'success'
          })
        }
      } catch (error) {
        this.showError('No se pudieron obtener los datos intentalo mas tarde.')
      }
    },
    async getDetailBuy () {
      try {
        const request = {
          enterprise_id: this.user.enterprise_id,
          id_buy: this.compra.id_buy,
          ticket: this.compra.ticket
        }
        // console.log('request getDetailBuy', request)
        const orders = await axiosAdelaService.post('/getDetailBuy', request)
        console.log('* * * ***** getDetailBuy', orders)
        if (orders.status === 200) {
          // console.log(orders)
          this.compra = orders.data.rows
          this.compra.date = moment(this.compra.date).format('YYYY-MM-DD')
          this.items = orders.data.rows.orders
        }
      } catch (error) {
        console.log('error getDetailBuy', error)
        this.showError('No se pudieron obtener los datos intentalo mas tarde.')
      }
    },
    async printEtiquetas () {
      try {
        this.tickets = []
        const params = {
          tickets: this.selected,
          enterprise: this.user.enterprise_id
        }
        console.log('parametros,printEtiquetas', params)
        const response = await axiosAdelaService.post('/getBarcodesforBarcode', params)
        console.log('getBarcodesforBarcode', response)
        if (response.status === 200) {
          const data = response.data
          for (const key in data) {
            data[key].date_buy = moment(data[key].date_buy).format('YYYY-MM-DD')
            this.tickets.push(data[key])
          }
          this.$refs.html2Pdf.generatePdf()
        }
      } catch (error) {
        this.showError('No se pudieron obtener el historial intentalo mas tarde.')
      }
    },
    async printCompra () {
      try {
        // console.log()
        this.$refs.reporte.generatePdf()
      } catch (error) {
        this.showError('No se pudieron obtener el historial intentalo mas tarde.')
      }
    },
    changeDescuento () {
      this.rowSelected.venta = this.rowSelected.precio - (this.rowSelected.porcentaje_descuento * 100 / this.rowSelected.precio)
    }
  },
  async mounted () {
    try {
      await this.getDetailBuy()
    } catch (error) {
      console.log('error mounted', error)
      this.showError('No se pudieron obtener los datos intentalo mas tarde.')
    }
  },
  created () {
    this.compra = this.$_.get(this.$route, 'params', {})
  }
}
</script>
<style>
.rowTable {
  font-size: 12px;
}
.etiqueta {
    width: 60mm !important;
    height: 22mm !important;
    /* background: red; */
    padding: 0px !important;
  }
  .etiqueta svg {

  }
  .labels {
    font-family: Arial, Helvetica, sans-serif;
    color: black;
    /* width: 60mm; */
    font-size: 11px;
    font-weight: 900;
    margin: auto;
  }
  .labels p {
    line-height: 1;
    margin: 0;
  }
  .endLabels {
    font-size: 8px;
  }
  .labelsComplete {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
  /* grid-auto-rows: minmax(66mm, auto); */
  }
  .printCompra {
    color: black;
  }
</style>
